"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const rxjs_1 = require("rxjs");
const util_rx_1 = require("./util_rx");
const operators_1 = require("rxjs/operators");
function firestoreCloneReference(from, toCollection, extra = {}) {
    return util_rx_1.promise$(() => from.get()).pipe(operators_1.flatMap(docSnap => docSnap.exists ?
        firestoreCloneSnapshot(docSnap, toCollection, extra)
        : rxjs_1.EMPTY));
}
exports.firestoreCloneReference = firestoreCloneReference;
function firestoreCloneSnapshot(from, toCollection, extra = {}) {
    const data = from.data();
    if (!data)
        return rxjs_1.throwError(`No data on docSnap ${from.id}`);
    return util_rx_1.promise$(() => toCollection.add(Object.assign(Object.assign({}, data), extra)));
}
exports.firestoreCloneSnapshot = firestoreCloneSnapshot;
function firestoreCloneCollection(fromCollection, toCollection, extra = {}) {
    return util_rx_1.promise$(() => fromCollection.get()).pipe(operators_1.flatMap((querySnap) => querySnap.empty ? rxjs_1.of([]) : rxjs_1.of(querySnap.docs)), operators_1.flatMap(array => {
        if (array.length === 0)
            return rxjs_1.of([]);
        const eachSnap = (docSnap) => firestoreCloneSnapshot(docSnap, toCollection, extra);
        return rxjs_1.zip(...array.map(eachSnap));
    }));
}
exports.firestoreCloneCollection = firestoreCloneCollection;
